var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m452.19 5.6922a11.287 11.287 0 00-2.4278.053744 11.287 11.287 0 00-7.2698 4.039l-42.265 51.609c-43.49-32.052-96.794-48.893-150.97-47.48-28.922.75431-58.09 6.7096-86.145 18.33-112.22 46.482-172.96 169.66-141.52 286.98 31.437 117.32 145.63 193.62 266.05 177.77 120.42-15.854 210.98-119.11 210.98-240.57h-79.002c0 82.428-60.562 151.49-142.28 162.25-81.723 10.759-158.1-40.271-179.43-119.89-21.334-79.619 19.292-162 95.445-193.54 53.478-22.151 112.27-14.153 156.83 17.273l-46.829 57.182a11.287 11.287 0 008.7323 18.438h172.05a11.287 11.287 0 0011.08-13.432l-32.904-169.91a11.287 11.287 0 00-10.115-9.0971z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.75eb6fbb96f226ab1e9c29020e999281.svg";
export { ForwardRef as ReactComponent };